import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 语言
import i18n from './i18n/i18n'

Vue.config.productionTip = false;

// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ellocale from 'element-ui/lib/locale'
import el_en from 'element-ui/lib/locale/lang/en'
import el_zh from 'element-ui/lib/locale/lang/zh-CN'
ellocale.use(localStorage.getItem('ilang')=='EN'?el_en:el_zh)
Vue.use(ElementUI,{ellocale});

// 全局事件
import utils from './utils/index'
Vue.use(utils)

// 公共组件
// 图片验证
import verify from "@/components/verify.vue";
Vue.component("verify", verify);
// 分页
import pages from "@/components/pages.vue";
Vue.component("pages", pages);
// 提示
import tip from "@/components/tip.vue";
Vue.component("tip", tip);
// 弹窗
import popup from "@/components/popup.vue";
Vue.component("popup", popup);

// 下载组件
import vdownload from "@/components/download.vue";
Vue.component("vdownload", vdownload);
// Axios
import requests from './api/index'
Vue.prototype.$axios = requests;
// system Axios
import sysapi from './api/sys'
Vue.prototype.$sysapi = sysapi;
//数据流下载
import downloadapi from './api/download'
Vue.prototype.$daxios = downloadapi;
//文件路径下载
import urldownloadapi from './api/urldownload'
Vue.prototype.$uaxios = urldownloadapi;
//无响应发送
import justpost from './api/post'
Vue.prototype.$justpost = justpost;
//搜索
import search from "@/components/search.vue";
Vue.component("search", search);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
